import styled from 'styled-components';
import { FONTS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

export const ModalBody = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  margin-top: 50px;
  box-sizing: border-box;
  text-align: center;
  max-width: 450px;
  padding: 0 15px 30px;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.h2`
  font-family: ${FONTS.ARISTOTELICA};
  font-size: 20px;
  line-height: 22px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 24px;
    line-height: 26px;
  }
`;

export const ButtonActive = styled(Button)`
  margin: 20px auto 0;
`;

export const LoaderWrapper = styled.span`
  right: 0;
  z-index: 10;
  width: 320px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const ErrorMessage = styled.span`
  font-size: 12px;
`;